import { Lightning, Router } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';
import { AtvKeyboardInput } from '../../components/keyboard/AtvKeyboardInput';
import { AtvKeyboardService } from '../../components/keyboard/AtvKeyboardService';
import { ProfileCatalogBox } from '../../components/profile/ProfileCatalogBox';
import { ProfileAvatarSelectionBox } from '../../components/profile/ProfileAvatarSelectionBox';
import { ProfileButton } from '../../components/profile/ProfileButton';
import { CatalogApi } from '../../api/profile/CatalogApi';
import { ProfileApi } from '../../api/profile/ProfileApi';
import { confirmCancelDialog } from '../dialogs/ConfirmCancelDialog';

const _constants = {
  maxWidth: 850,
  rectRadius: 20,
  inputFieldHeight: 60,
  buttonHeight: 80,
  buttonWidth: 700,
  margin: 20,
  titleHeight: 76,
  inputHeight: 120,
  avatarSelection: 140,
  padding: 15,
  leftPadding: 30,
  inputTitleHeight: 40,
};

export class ProfileEditPage extends Lightning.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      color: Theme.Colors.ProfilePage.Background,
      rect: true,
      ContentContainer: {
        mount: 0.5,
        x: w => w / 2,
        y: h => h / 2,
        h: h => h,
        w: _constants.maxWidth,
        flex: {
          direction: 'column',
          justifyContent: 'center',
        },
        Title: {
          x: w => w / 2,
          mountX: 0.5,
          text: {
            text: '',
            textAlign: 'center',
            ...Theme.Fonts.Default,
          },
        },
        InputNameBox: {
          shader: {
            type: Lightning.shaders.RoundedRectangle,
            radius: _constants.rectRadius,
          },
          flexItem: {
            marginTop: _constants.margin,
          },
          x: 0,
          y: 0,
          w: w => w,
          h: _constants.inputHeight,
          color: Theme.Colors.ProfilePage.InteractionUnfocused,
          rect: true,
          InputNameTitle: {
            x: _constants.leftPadding,
            y: _constants.padding,
            h: _constants.inputTitleHeight,
            text: {
              text: 'Naam',
              fontSize: 26,
              ...Theme.Fonts.Normal,
            },
          },
          SearchInputField: {
            mountY: 1,
            x: _constants.leftPadding,
            y: _constants.inputHeight - _constants.padding,
            h: _constants.inputFieldHeight,
            w: _constants.maxWidth,
            type: AtvKeyboardInput,
            signals: {},
            inputColors: {
              focus: 0x00000000,
              unfocus: 0x00000000,
            },
            textColor: 0xffafc0cd,
          },
        },
        CatalogBox: {
          rect: true,
          w: _constants.maxWidth,
          h: _constants.inputHeight,
          color: Theme.Colors.ProfilePage.InteractionUnfocused,
          shader: {
            type: Lightning.shaders.RoundedRectangle,
            radius: _constants.rectRadius,
          },
          flexItem: {
            marginTop: _constants.margin,
          },
          type: ProfileCatalogBox,
        },
        AvatarSelection: {
          type: ProfileAvatarSelectionBox,
          rect: true,
          w: _constants.maxWidth,
          h: _constants.avatarSelection,
          color: Theme.Colors.Transparent,
          flexItem: {
            marginTop: _constants.margin,
          },
        },
        HorizontalButtons: {
          mountX: 0.5,
          x: _constants.maxWidth / 2,
          w: _constants.buttonWidth,
          h: _constants.buttonHeight,
          flexItem: {
            marginTop: _constants.margin,
          },
          Button1: {
            type: ProfileButton,
            w: _constants.buttonWidth / 2 - 20,
            h: _constants.buttonHeight,
            x: 0,
            radius: _constants.rectRadius,
            fontSize: 28,
            signals: {
              onActivate: '_cancelButtonPress',
            },
          },
          Button2: {
            type: ProfileButton,
            w: _constants.buttonWidth / 2 - 20,
            h: _constants.buttonHeight,
            x: _constants.buttonWidth / 2 + 20,
            radius: _constants.rectRadius,
            fontSize: 28,
            signals: {
              onActivate: '_confirmButtonPress',
            },
          },
        },
        Button3: {
          mountX: 0.5,
          x: _constants.maxWidth / 2,
          flexItem: {
            marginTop: _constants.margin,
          },
          type: ProfileButton,
          w: _constants.buttonWidth,
          h: _constants.buttonHeight,
          radius: _constants.rectRadius,
          fontSize: 28,
          signals: {
            onActivate: '_deleteProfileButtonPress',
          },
        },
      },
    };
  }

  _init() {
    this.tag('Title').text.text = this.backend.translations.forKey('profile_edit_title');
    this.tag('InputNameTitle').text.text = this.backend.translations.forKey('profile_property_name');
    // console.log('Edit Page Data', this.data, this.backend);
    this.right = false;
    AtvKeyboardService.init(this);

    CatalogApi.avatarList(this.backend).then(r => {
      this.tag('AvatarSelection').data = { data: this.data, avatars: r };
    });

    CatalogApi.list(this.backend).then(r => {
      this.tag('CatalogBox').data = { backend: this.backend, data: this.data, catalogs: r };
    });

    this.tag('Button1').title = this.backend.translations.forKey('profile_cancel_btn');
    this.tag('Button3').title = this.backend.translations.forKey('profile_delete_btn');

    if (this.data === undefined) {
      // new account
      this.tag('Title').text.text = this.backend.translations.forKey('profile_add_title');
      this.tag('Button2').title = this.backend.translations.forKey('profile_create_btn');
      this.tag('SearchInputField').inputField._description = this.backend.translations.forKey(
        'profile_property_name_placeholder'
      );
    } else {
      // console.log(this.tag('SearchInputField').inputField);
      this.tag('SearchInputField').inputField._description = this.data.profile.name;
      // this.tag('SearchInputField').inputField._cursorIndex = 3;

      this.tag('Button2').title = this.backend.translations.forKey('profile_save_btn');
    }
    this._index = 0;
    if (this.data && this.allowDelete) {
      this._items = ['SearchInputField', 'CatalogBox', 'AvatarSelection', 'Button1', 'Button3'];
    } else {
      this._items = ['SearchInputField', 'CatalogBox', 'AvatarSelection', 'Button1'];
      this.tag('Button3').visible = false;
    }
    this._input = undefined;
    this.tag('SearchInputField').signals.onChanged = (e, result) => {
      this._input = result.input;
      // console.log('Keyboard on changed', result.input);
    };
  }

  _getFocused() {
    if (AtvKeyboardService.instance && AtvKeyboardService.instance.isOpen) {
      return AtvKeyboardService.instance.keyboard;
    }
    this.tag('InputNameBox').color = Theme.Colors.ProfilePage.InteractionUnfocused;
    if (this._index === 0) {
      this.tag('InputNameBox').color = Theme.Colors.ProfilePage.InteractionFocused;
    }
    if (this._index === 3 && this.right) {
      return this.tag('Button2');
    }
    return this.tag(this._items[this._index]);
  }

  _detach() {
    AtvKeyboardService.removeInstance();
  }

  _handleRight() {
    if (this._index === 3) {
      this.right = true;
    }
  }

  _handleLeft() {
    this.right = false;
  }

  _handleUp() {
    this.right = false;
    if (this._index > 0) {
      this._index -= 1;
    }
  }

  _handleDown() {
    this.right = false;
    if (this._index < this._items.length - 1) {
      this._index += 1;
    }
  }

  _handleBack() {
    this.fireAncestors('$closeDialog');
  }

  _cancelButtonPress() {
    this.fireAncestors('$closeDialog');
  }

  _confirmButtonPress() {
    if (this.data) {
      this.saveAccount();
    } else {
      this.makeAccount();
    }
  }

  _deleteProfileButtonPress() {
    this.confirmDeleteAccount();
  }

  confirmDeleteAccount() {
    if (this.backend.deviceProfile.id === this.data.id) {
      // show pop-up Fout, Het profiel is in gebruik
      this.fireAncestors(
        '$showMessage',
        this.backend.translations.forKey('AA_PROFILE_IN_USE'),
        this.backend.translations.forKey('error_title'),
        undefined
      );
    } else {
      this.fireAncestors(
        '$openDialog',
        confirmCancelDialog(
          undefined,
          this.backend.translations.forKey('profile_delete_confirm'),
          this.deleteAccount.bind(this),
          undefined,
          this.backend.translations.forKey('popup_btn_ok'),
          this.backend.translations.forKey('profile_cancel_btn')
        ),
        true
      );
    }
  }

  deleteAccount() {
    ProfileApi.delete(this.backend, this.data.id).then(_r => {
      // console.log('Account deleted', r);
      this.fireAncestors('$closeDialog');
    });
  }

  saveAccount() {
    if (this._input === '' || this._input === undefined) {
      this._input = this.data.profile.name;
    }
    let selectedCatalog = this.tag('CatalogBox').selectedChannel;
    let selectedAvatar = this.tag('AvatarSelection').selectedAvatar;
    let newProfile = {
      name: this._input,
      catalog: selectedCatalog.id,
      avatar: selectedAvatar.id,
      parentalControl: this.data.profile.parentalControl,
    };
    ProfileApi.update(this.backend, this.data.id, newProfile).then(savedProfile => {
      // console.log('SaveAcc finished', r);
      this.fireAncestors('$closeDialog');
      this._checkReloadProfile(savedProfile);
    });
  }

  makeAccount() {
    if (this._input === undefined) {
      // error input cant be empty
      this.fireAncestors(
        '$showMessage',
        this.backend.translations.forKey('profile_error_name'),
        this.backend.translations.forKey('error_title'),
        undefined
      );
      return;
    }
    let selectedCatalog = this.tag('CatalogBox').selectedChannel;
    let selectedAvatar = this.tag('AvatarSelection').selectedAvatar;
    let newProfile = {
      name: this._input,
      catalog: selectedCatalog.id,
      avatar: selectedAvatar.id,
    };
    ProfileApi.create(this.backend, newProfile).then(_r => {
      // console.log('Create finished', r);
      this.fireAncestors('$closeDialog');
    });
  }

  _checkReloadProfile(savedProfile) {
    if (
      this.backend.deviceProfile.id === savedProfile.id &&
      (this.backend.deviceProfile.profile.name !== savedProfile.profile.name ||
        this.backend.deviceProfile.profile.catalog !== savedProfile.profile.catalog)
    ) {
      Router.getActivePage().fireAncestors('$updateSession');
    }
  }
}
